import { getDefaultConfig } from '../base.js';

const envConfig = {
    subDomain: undefined,
    rootDomain: 'casino.fanduel.com',
    internalNamespace: 'web-fanduel-casino-use1',
    apis: {
        AmplitudeExperimentClient: {
            apiKey: 'server-t8LQgdvqM94XjlSWDNStiPCcPIa1RJSw'
        },
        BanneringToolClient: {
            host: 'casino-bannering-tool.casino.fanduel.com'
        },
        TransactionHistory: {
            baseUrl: 'https://api.statePlaceholder.casino.fanduel.com'
        },
        CppClient: {
            baseUrl: 'https://promos-api.casino.fanduel.com'
        },
        SiteWideJackpotClient: {
            host: 'api.statePlaceholder.casino.fanduel.com'
        },
        MdsClient: {
            baseUrl: 'mds.statePlaceholder.casino.fanduel.com'
        },
        CasinoSearchClient: {
            host: 'casino-search.casino.fndlext.net',
            headers: {
                'x-api-key': 'Id5JOd8AhY4OkkcCICr7c4fGGMdj8UDB7VIN1Ocv'
            }
        }
    },
    services: {
        amplitudeKey: '37bc6a03c048c47939a6ffb7b7ef9fc3',
        braze: {
            key: 'e8b4df14-5c84-41a0-bf9c-dff5530828fc',
            product: 'FD-CASINO'
        },
        smartBanner: {
            id: 1506229470
        },
        snowplow: {
            appId: 'casino-web',
            androidAppId: 'casino-android',
            trackerUrl: 'partner.sp.prd.use1.data.fndlext.net'
        }
    },
    unifiedModules: {
        env: 'prod',
        clientId: '023ea2d401b9e8be054d25f2d01e0292',
        pxEnabled: true
    },
    perimeterx: {
        appId: 'JMCVuBG8'
    },
    debug: {
        hideDebugMenu: true
    },
    seo: {
        noIndex: false,
        sitemap: true
    },
    publicCache: 100,
    otherCountries: [
        {
            countryCode: 'canada',
            link: 'https://casino.fanduel.ca'
        }
    ]
};

export const config = getDefaultConfig(envConfig);
